import React, {Component} from 'react';
import Slider from "react-slick";

import './styles/wear-collection.scss';

import { maxTabletWidth, spaceRatio } from '../../helpers/constans';

export default class WearCollection extends Component {

  constructor(props) {
    super();

    this.state = {
      currentSlide: 0,
      sliderProgressVisible: false,
      menuParamCount: 0, // width (desktop) or height (tablet and mobile)
      sliderCount: 8,
      screenDesktop: true,
      disabledSliderBtn: false,
    }
  }

  componentDidMount() {
    this.setState({
      menuParamCount: window.innerWidth >= maxTabletWidth ? document.getElementById('sliderMenu').offsetWidth : document.getElementById('sliderMenu').offsetHeight,
      screenDesktop: window.innerWidth >= maxTabletWidth,
    });

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  changeSlide(slideNumber) {
    if (slideNumber === this.state.changeSlide) {
      return false;
    }

    this.setState({
      currentSlide: slideNumber,
    })
  }

  /**
   * Find active menu item and calculate left position relative to them
   */
  getScrollPosition() {
    const { sliderCount, currentSlide } = this.state;
    const progress = this.props.progress;

    const relativeStep = (sliderCount * progress) - currentSlide;

    const menu = document.querySelector('#sliderMenu');
    const activeMenuItem = menu?.querySelector('._active');

    if (!activeMenuItem) return 0;

    const { offsetLeft, offsetWidth } = activeMenuItem;
    let position = 0;

    if (currentSlide === 1) {
      position = offsetLeft + offsetWidth * relativeStep / 2;
    } else if (currentSlide === 2) {
      position = (offsetLeft + offsetWidth / 2) + offsetWidth * relativeStep / 2;
    } else {
      position = offsetLeft + offsetWidth * relativeStep;
    }

    return position;
  }

  updateSliderPosition() {
    const progressBar = document.querySelector('#progress_desktop');
    if (!progressBar) return;

    progressBar.style.transform = `translateX(${this.getScrollPosition()}px)`;
  }

  componentDidUpdate(prevProps, prevState) {
    const { sliderCount } = this.state;
    const progress = this.props.progress;

    const relativeStep = Math.floor(sliderCount * progress);
    const step = relativeStep > 0 ? relativeStep : 0;

    if (step !== this.state.currentSlide) {
      this.slider.slickGoTo(step >= sliderCount ? sliderCount - 1 : step);
    }
    this.updateSliderPosition();
  }

  selectSlide(numberSlide) {
    this.slider.slickGoTo(numberSlide);

    if (this.state.disabledSliderBtn) {
      return;
    }

    this.setState({
      disabledSliderBtn: true,
    });

    this.slider.slickGoTo(numberSlide);
    this.scrollToSection(numberSlide);

    setTimeout(() => {
      this.setState({
        disabledSliderBtn: false,
      });
    }, 500);
  }

  scrollToSection(numberSlide) {
    const { sliderCount } = this.state;
    const sectionDuration = this.props.eventParams?.currentTarget?.duration() / (sliderCount);

    const scrollOffset = this.props.eventParams?.currentTarget?.scrollOffset();

    const scrollPosition =  scrollOffset + 1 + (sectionDuration * numberSlide);

    this.props.eventParams?.currentTarget?.controller().scrollTo(scrollPosition);
  }

  handleResize() {
    this.setState({
      menuParamCount: window.innerWidth >= maxTabletWidth ? document.getElementById('sliderMenu').offsetWidth : document.getElementById('sliderMenu').offsetHeight,
      screenDesktop: window.innerWidth >= maxTabletWidth,
    })
  }

  render() {

    const {
      progress,
    } = this.props;

    const settings = {
      arrows: false,
      dots: false,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 800,
      cssEase: "linear",
      swipe: false,
      beforeChange: (currentSlide, nextSlide) => {
        this.changeSlide(nextSlide);

        if (currentSlide === nextSlide) {
          return false;
        }

        const slides = document.querySelectorAll('.slider__wear__info');

        // animations
        slides[currentSlide].classList.add('_hide');

        setTimeout(() => {
          slides[currentSlide].classList.remove('_show');
          slides[currentSlide].classList.remove('_hide');
        }, 500);

        if (nextSlide === 0) {
          this.setState({
            sliderProgressVisible: false,
          });
        } else if (nextSlide === 1) {
          this.setState({
            sliderProgressVisible: true,
          });
        }
      },
      afterChange: (nextSlide) => {
        const slides = document.querySelectorAll('.slider__wear__info');

        // animations
        slides[nextSlide].classList.add('_show');
      }
    };

    return(
      <div className="slider" id="wearCollection">
        <div className="slider__wrapper">
          <div className="slider__menu">
            <p>Composition & Care</p>
            <div className="slider__menu__list" id="sliderMenu">
              <ul>
                <li className="js-menu-item" style={{ width: '30px' }}></li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(1)} className={this.state.currentSlide === 1 || this.state.currentSlide === 2 ? '_active' : ''}>T-Shirt</button>
                </li>
                <li className="js-menu-item empty"></li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(3)} className={this.state.currentSlide === 3 ? '_active' : ''}>Longsleeve</button>
                </li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(4)} className={this.state.currentSlide === 4 ? '_active' : ''}>Hoodie</button>
                </li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(5)} className={this.state.currentSlide === 5 ? '_active' : ''}>Vest</button>
                </li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(6)} className={this.state.currentSlide === 6 ? '_active' : ''}>Pants</button>
                </li>
                <li className="js-menu-item">
                  <button onClick={() => this.selectSlide(7)} className={this.state.currentSlide === 7 ? '_active' : ''}>Scarf</button>
                </li>
              </ul>
              {
                this.state.screenDesktop
                ? <div id="progress_desktop" className={`slider__menu__list__progress _desktop ${this.state.currentSlide > 0 ? '_show' : ''}`}></div>
                : <div className={`slider__menu__list__progress _mobile ${this.state.currentSlide > 0 ? '_show' : ''} `} style={{transform: `translateY(${progress >= 0.23 ? (this.state.menuParamCount * (progress - 0.15)) : 0}px)`}}></div>
              }
            </div>
          </div>
          <div className="slider__wear">
            <Slider ref={slider => (this.slider = slider)} {...settings}>
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/discover.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info _show">
                  <div className="slider__wear__info__title">
                    <p>Discover our collection</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Do Deep Tech Garments collection includes black and white t-shirts, longsleeve, hoodie, vest, pants, and scarf.</p>
                  </div>
                </div>
              </div>

              {/* Black T-shirt */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/t-shirt.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>T-shirt</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Versatile oversized cotton T-shirt. Cotton is&nbsp;a&nbsp;practical material with excellent qualities. It&rsquo;s one of&nbsp;the best materials to&nbsp;pair with lycra. The resulting textile is&nbsp;breathable, moisture-absorbing, and hypoallergenic. Lycra provides the necessary elasticity and prevents warping of&nbsp;the cotton fabric.</p>
                    <p>Composition: 92% cotton, 8%&nbsp;lycra</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-7.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-16.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* White T-shirt */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/t-shirt.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>T-shirt</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Versatile oversized cotton T-shirt. Cotton is a practical material with excellent qualities. It's one of the best materials to pair with lycra. The resulting textile is breathable, moisture-absorbing, and hypoallergenic. Lycra provides the necessary elasticity and prevents warping of the cotton fabric.</p>
                    <p>Composition: 92% cotton, 8% lycra</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-7.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-16.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* Longsleeve */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/t-shirt.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>Longsleeve</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Longsleeve made of french terry. It's an all natural cotton fabric — smooth on the outside, soft and delicate on the inside, and very comfortable. These qualities are achieved by the special interweaving of the threads during production. The resulting material is soft, hygroscopic and colorfast.</p>
                    <p>Composition: 100% cotton</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-7.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-16.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* Hoodie */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/hoodie.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>Hoodie</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Hoodie made of&nbsp;french terry. It&rsquo;s an&nbsp;all natural cotton fabric&nbsp;&mdash; smooth on&nbsp;the outside, soft and delicate on&nbsp;the inside, and very comfortable. These qualities are achieved by&nbsp;the special interweaving of&nbsp;the threads during production. The resulting material is&nbsp;soft, hygroscopic and colorfast.</p>
                    <p>Composition: 100% cotton</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-7.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-16.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* Vest */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require('../../static/images/slider/vest.jpg').default})` }}></div> */}
                <div className="slider__wear__bg"></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>Vest</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>The fabric of&nbsp;the vest provides comfort and confidence in&nbsp;a&nbsp;variety of&nbsp;weather conditions. It&nbsp;retains heat perfectly, withstands extreme temperature fluctuations, resists mechanical and chemical damage, and is&nbsp;durable and environmentally friendly.</p>
                    <p>Main fabric: 100% polyester<br />Interlayer: 95% polyester, 5%&nbsp;spandex<br />Lining fabric: 100% polyester</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-13.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-16.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* Pants */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require(`../../static/images/slider/${window.innerWidth < 1200 ? 'pants-other' : 'pants'}.jpg`).default})` }}></div> */}
                <div className="slider__wear__bg" ></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>Pants</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Double-layered trousers. The outer layer is&nbsp;waterproof dewspo fabric, the inner layer is&nbsp;knitted fabric. The layers are securely bonded with polyurethane. Double layering gives the dewspo fabric a&nbsp;higher density and good heat-shielding abilities, while maintaining its unique properties.</p>
                    <p>Composition: 100% polyester</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-15.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-7.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-8.svg').default} alt="" />
                  </div>
                </div>
              </div>

              {/* Scarf */}
              <div className="slider__wear__item">
                {/* <div className="slider__wear__bg" style={{ backgroundImage: `url(${require(`../../static/images/slider/${window.innerWidth < 1200 ? 'pants-other' : 'pants'}.jpg`).default})` }}></div> */}
                <div className="slider__wear__bg" ></div>
                <div className="slider__wear__info">
                  <div className="slider__wear__info__title">
                    <p>Scarf</p>
                  </div>
                  <div className="slider__wear__info__desc">
                    <p>Main fabric: 100% polyester
                    <br />Lining fabric: 83% polyester, 17% spandex
                    <br />Insulation: 100% fine-fiber polyester</p>
                  </div>
                  <div className="slider__wear__info__params">
                    <img src={require('../../static/images/slider/icon-5.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-6.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-17.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-4.svg').default} alt="" />
                    <img src={require('../../static/images/slider/icon-18.svg').default} alt="" />
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    )
  }
}
